interface Tag {
  name: string
}
interface ByFavoriteProps {
  tags: Tag[]
}

export const hasFavoriteTag = (tags: Tag[]) =>
  tags.find(({ name }) => name === 'Favorites')
export const byFavorite = ({ tags }: ByFavoriteProps) => hasFavoriteTag(tags)
